import React, { useEffect, useState, useRef } from "react";
import EnhanceTable from "../../table/table";
import {
  Button,
  TextField,
  Grid,
  Typography,
  DialogContent,
  DialogActions,
  DialogTitle,
  Dialog,
} from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import AdminModal from "../../modal/adminModal";
import Snackbar from "../../snackbar/snackbar";
import { getData, postData, currentDate } from "../../actions";
import csv from "papaparse";
import GetAppIcon from "@material-ui/icons/GetApp";
import CircularProgress from "@material-ui/core/CircularProgress";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import FileDownload from "js-file-download";
import json2csv from "json2csv";
import axios from "axios";
const convertToCSV = json2csv.parse;

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
  confirm: {
    zIndex: 999,
  },
  conFirmLabel: {
    fontWeight: "bold",
  },
}));

const AddModal = (props) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [codeField, setCodeField] = useState();
  const [nameField, setNameField] = useState();
  const [vatSelected, setVatSelected] = useState("X1");
  const [snackbar, setSnackbar] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [wtaxSelected, setWtaxSelected] = useState({
    wTaxCode: "X1",
    wTaxName: "None",
    wTaxDisplayName: "None (X1)",
    rate: "0",
  });

  const addVendor = async () => {
    setIsLoading(true);
    setConfirmModal(false);
    const doesExist = props.existingData.filter(
      (vendor) => vendor.bpCode === codeField
    );
    if (doesExist.length > 0) {
      alert("Vendor already exist!");
      setCodeField("");
      setNameField("");
      setIsLoading(false);
      return;
    }
    postData("/vendors/create", {
      bpCode: codeField.trim(),
      bpName: nameField.trim(),
      vatType: vatSelected,
      wTaxCode: wtaxSelected.split("➡")[0],
    }).then(() => {
      props.existingData.push({
        bpCode: codeField.trim(),
        bpName: nameField.trim(),
        vatType: vatSelected,
      });
      setIsLoading(false);
      alert(`Vendor with Code <${codeField}> successfuly added`);
      setCodeField("");
      setNameField("");
      setVatSelected("");
      setWtaxSelected("");
      props.handleClose(codeField);
    }).catch(error => {
      props.handleClose("Cancel")
        
    });
  };
  const confirm = (
    <>
      <Dialog className={classes.confirm} open={confirmModal}>
        <DialogTitle>Confirm Vendor Details</DialogTitle>
        <DialogContent>
          <Typography>
            Vendor Code:{" "}
            <span className={classes.conFirmLabel}>{codeField}</span>
          </Typography>
          <Typography>
            Vendor Name:{" "}
            <span className={classes.conFirmLabel}>{nameField}</span>
          </Typography>
          <Typography>
            Vat Type:{" "}
            <span className={classes.conFirmLabel}>{vatSelected}</span>
          </Typography>
          <Typography>
            Withholding Tax:{" "}
            <span className={classes.conFirmLabel}>{wtaxSelected}</span>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            variant="contained"
            disabled={isLoading}
            onClick={() => setConfirmModal(false)}
          >
            Cancel
          </Button>
          <Button
            color="secondary"
            variant="contained"
            disabled={isLoading}
            onClick={() => addVendor()}
          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
  const handleCloseThis = () => {
    props.handleClose("Cancel")
  }
  return (
    <>
      {confirm}
      {isLoading ? (
        <Backdrop className={classes.backdrop} open={isLoading}>
          <CircularProgress color="inherit" />
        </Backdrop>
      ) : (
        <AdminModal
          title="Vendor Enrollment to CRIS"
            open={props.open}
            handleClose={handleCloseThis}
        >
          <div style={{ width: "100%", maxWidth: "400px" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12}>
                <TextField
                  type="text"
                  variant="outlined"
                  label="SAP Vendor Code"
                  size="small"
                  value={codeField}
                  onChange={(e) => {
                    setCodeField(e.target.value);
                  }}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <TextField
                  variant="outlined"
                  label="Vendor Name"
                  size="small"
                  value={nameField}
                  onChange={(e) => {
                    setNameField(e.target.value);
                  }}
                  fullWidth
                  required
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id="vatType"
                  options={["X1", "IVAT-S", "IVAT-G", "IVAT-I", "DIV-S"]}
                  getOptionLabel={(option) => option}
                  fullWidth
                  required
                  inputValue={vatSelected}
                  onInputChange={(x, inputValue) => setVatSelected(inputValue)}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Vat Type"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Autocomplete
                  id="wtaxOptions"
                  required
                  options={props.wtaxes}
                  getOptionLabel={(option) =>
                    `${option.wTaxCode}➡ ${option.wTaxDisplayName}`
                  }
                  fullWidth
                  inputValue={wtaxSelected}
                  onInputChange={(e, inputValue) => setWtaxSelected(inputValue)}
                  size="small"
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Withholding Tax"
                      variant="outlined"
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                <Button
                  type="submit"
                  color="primary"
                  style={{ float: "right" }}
                  onClick={() => {
                    setConfirmModal(true);
                  }}
                  disabled={isLoading}
                >
                  Add
                </Button>
              </Grid>
            </Grid>
          </div>
        </AdminModal>
      )}
    </>
  );
};

export default AddModal;
